<template>
    <v-container fluid>
        <v-layout align-center>
            <v-flex>
                <div class="headline mb-2">
                    Endringsmelding
                </div>
            </v-flex>
            <v-flex>
                <v-text-field class="pb-2" v-model="search" append-icon="mdi-magnify" label="Søk..." single-line
                              hide-details outlined dense/>
            </v-flex>
            <v-flex/>
            <v-flex shrink>
                <v-btn color="green" dark :to="{name: 'CreateAmendment'}" class="mb-3">
                    <v-icon left>add</v-icon>
                    Ny endringsmelding
                </v-btn>
            </v-flex>
        </v-layout>
        <v-progress-linear indeterminate v-if="loading"/>
        <v-data-table :headers="headers" :items="amendments" v-else class="elevation-1 table-condensed"
                      hide-default-footer :search="search" :custom-filter="customFilter"
                      :items-per-page="-1" sort-by="id" sort-desc>
            <template v-slot:body="{ items }">
                <tbody>
                <tr v-for="amendment in items" :key="amendment.id" @click="goToAmendment(amendment)">
                    <td class="text-right font-weight-bold">{{ amendment.project }}-{{ amendment.amendment_number }}
                    </td>
                    <td class="font-weight-bold">{{ amendment.project_name }}</td>
                    <td>{{ amendment.title }}</td>
                    <td>{{ formatDate(amendment.date) }}</td>
                    <td>{{ formatDate(amendment.date_revised) }}</td>
                    <td>kl. {{ formatTime(amendment.modified) }}</td>
                    <td>{{ amendment.customer_ref }}</td>
                    <td class="text-center">
                        <v-icon color="green" v-if="amendment.is_extra_material">check</v-icon>
                    </td>
                    <td class="text-center">
                        <v-icon color="green" v-if="amendment.is_extra_work">check</v-icon>
                    </td>
                    <td class="text-center">
                        <v-icon color="green" v-if="amendment.is_price_adjustment">check</v-icon>
                    </td>
                    <td class="text-right">{{ formatMoney(amendment.sum) }}</td>
                </tr>
                <tr v-if="!items.length">
                    <td colspan="3">Ingen endringsmelding funnet.</td>
                </tr>
                </tbody>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    import {formatDate, formatMoney, formatNumber, formatTime} from "../helpers";

    export default {
        data() {
            return {
                loading: false,
                search: '',
                amendments: []
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            formatMoney,
            formatNumber,
            formatTime,
            formatDate,
            loadData() {
                this.loading = true;
                this.$http.get(`amendments/`).then(response => {
                    this.amendments = response.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
            goToAmendment(amendment) {
                this.$router.push({name: 'EditAmendment', params: {id: amendment.id}});
            },

            customFilter(value, search, item) {
                let searchValue = [];
                Object.keys(item).forEach(key => {
                    if (typeof item[key] === 'string' || typeof item[key] === 'number') {
                        searchValue.push(('' + item[key]).toLowerCase());
                    }
                });
                if (item.is_extra_material) searchValue.push('masseavregning');
                if (item.is_extra_work) searchValue.push('tilleggsarbeid');
                if (item.is_price_adjustment) searchValue.push('prisstigning');
                return searchValue.join(' ').indexOf(search.toLowerCase()) !== -1;
            }
        },

        computed: {
            headers() {
                return [
                    {text: 'Nr.', value: 'amendment_number', align: 'right', width: '120px'},
                    {text: 'Prosjekt', value: 'project'},
                    {text: 'Kort beskrivelse', value: 'description'},
                    {text: 'Dato', value: 'date'},
                    {text: 'Dato revidert', value: 'date_revised'},
                    {text: 'Sist endret', value: 'modified'},
                    {text: 'Prosjektleder', value: 'customer_ref'},
                    {text: 'Masseavr.', value: 'is_extra_material', align: 'center', width: '120'},
                    {text: 'Tilleggsarb.', value: 'is_extra_work', align: 'center', width: '120'},
                    {text: 'Prisstigning', value: 'is_price_adjustment', align: 'center', width: '120'},
                    {text: 'Sum (eks. mva)', value: 'sum', align: 'right'}
                ]
            }
        }
    }
</script>